import { useSelector } from 'react-redux';
import { getVariantStock } from 'domains/Catalog/Products/productsSlice/productSelectors';

function useVariantStock(id: string) {
  const variantStock = useSelector(getVariantStock);
  return variantStock[id];
}

export default useVariantStock;
